import { cn } from "@/lib/utils";
import { memo } from "react";

type CarouselSlideProps = {
  reverse?: boolean;
} & React.ComponentProps<"div">;

const CarouselSlide: React.FC<CarouselSlideProps> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <div
      className={cn(
        "relative flex w-full min-h-full [&>*]:flex-auto [&>*]:min-w-0",
        className
      )}
      data-carousel-slide
      {...rest}
    >
      {children}
    </div>
  );
};

export default memo(CarouselSlide);
